import { filesize } from "filesize";

export default function FileSize({ value, ...others }) {
  return value && filesize(value, others);
}
